import { Action } from '../../../xs/actions';

export class RefreshCobrandingLogoAction implements Action {
  static readonly type = '[Sidenav] Refresh Cobranding Logo';
}
